import { render, staticRenderFns } from "./footerAll.vue?vue&type=template&id=19a5a53e&scoped=true&"
import script from "./footerAll.vue?vue&type=script&lang=js&"
export * from "./footerAll.vue?vue&type=script&lang=js&"
import style0 from "./footerAll.vue?vue&type=style&index=0&id=19a5a53e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a5a53e",
  null
  
)

export default component.exports